import { Box, Typography } from '@mui/material'
import React from 'react'

import { Rule, RuleBox } from './RuleBox'

interface RuleListProps {
  rules: Array<Rule>
  title: string
}

const RuleList: React.FC<RuleListProps> = (props) => {
  const { title, rules } = props
  return (
    <Box>
      <Box display="flex" padding={1}>
        <Typography variant="h3">{title}</Typography>
      </Box>
      <Box display="flex" flexDirection="column" width="100%">
        {rules.map((item, index) => (
          <RuleBox details={item.details} key={index} reason={item.reason} summary={`${index + 1}. ${item.summary}`} />
        ))}
      </Box>
    </Box>
  )
}

export default RuleList
